
    import {Inject, Options, Vue} from 'vue-property-decorator';
    import RecommendationSide from '@/profile-creation-wizard/components/for-completion/ui/6_recommendation/RecommendationSide.vue';
    import {ReasonForJoining} from '@/profile-creation-wizard/components/for-completion/domain/types';
    import {DI} from '@/profile-creation-wizard/common/DependencyInjection';
    import {ProfileCompletionRepositoryAPI} from '@/profile-creation-wizard/components/for-completion/infra/repository/ProfileCompletionRepositoryAPI';
    import AskForRecommendation from '@/profile-creation-wizard/components/for-completion/ui/6_recommendation/AskForRecommendation.vue';
    import {pushNotification} from '@malt/joy-entrypoint/src/js/notification';
    import StepActions from '@/profile-creation-wizard/common/ui/step/StepActions.vue';
    import StepMobileHeader from '@/profile-creation-wizard/common/ui/step/StepMobileHeader.vue';
    import {TrackingRepository} from '@/common/repositories/track/TrackingRepository';
    import {StepNavigator} from '@/profile-creation-wizard/common/step/StepNavigator';

    type Form = {
        reasonForJoining: Array<ReasonForJoining>;
        recoEmails: string;
        recoTextToSend: string;
    };

    const defaultForm: Form = {
        reasonForJoining: [],
        recoEmails: '',
        recoTextToSend: '',
    };

    @Options({
        components: {
            AskForRecommendation,
            RecommendationSide,
            StepActions,
            StepMobileHeader,
        },
    })
    export default class RecommendationStep extends Vue {
        @Inject({from: DI.profileCompletionRepository})
        profileCompletionRepository!: ProfileCompletionRepositoryAPI;
        @Inject({from: DI.trackingRepository})
        trackingRepository!: TrackingRepository;
        data: Form = defaultForm;
        progressPercentage = 0;

        stepName = 'recommendation';
        isLoadingButtonNext = false;

        created(): void {
            this.trackingRepository.track('recommendation-view-page-v2');
            if (this.$router.currentRoute.value.meta.progressPercentage) {
                this.progressPercentage = this.$router.currentRoute.value.meta.progressPercentage;
            }

            const meta = this.$router.currentRoute.value.meta;
            this.progressPercentage = meta.progressPercentage || 0;
            this.stepNavigator = new StepNavigator(this.$router, meta.previousStep, meta.nextStep);
        }

        get hasValidFieldPart(): boolean {
            return this.hasRecoToSend;
        }

        get hasRecoToSend(): boolean {
            return this.data.recoEmails.trim().length > 0 && this.data.recoTextToSend.trim().length > 0;
        }

        changeRecoEmails(emails: string): void {
            this.data.recoEmails = emails;
        }

        changeRecoText(text: string): void {
            this.data.recoTextToSend = text;
        }

        goToPrevious(): void {
            this.stepNavigator.previous();
        }

        async goNext(): Promise<void> {
            this.isLoadingButtonNext = true;
            if (this.hasRecoToSend) {
                const [, error] = await this.profileCompletionRepository.sendRecommendationRequests(this.data.recoEmails, this.data.recoTextToSend);
                if (error && error.response?.data.length > 0) {
                    this.isLoadingButtonNext = false;
                    pushNotification(error.response?.data[0].error, {level: 'error'});
                    return;
                }
            }

            this.trackingRepository.track('sent-recommendations-v2', {
                'sent-recommendations': this.hasRecoToSend ? this.data.recoEmails.split(',').length : 0,
            });

            this.stepNavigator.next();
            this.isLoadingButtonNext = false;
        }
    }
